/** The component list is written once per render, from the engine bridge. */

import type { RenderResult } from "../../engine/render/index.ts";
import { componentListToXlsx } from "../../lib/componentListXlsx.ts";
import { download } from "../../lib/download.ts";
import type { Result } from "../../lib/result.ts";
import { setHud } from "../hud/hud.actions.ts";
import { bomState } from "./bom.state.ts";

export function setBomFromRender(result: RenderResult): void {
  bomState.set({
    rows: result.bomRows,
    totalKg: result.totalKg,
    jackExtensions: result.jacks.map((jack) => jack.ext),
    raisedCount: result.jacks.filter((jack) => jack.raised).length,
    anyNonModuleDiagonal: result.anyNonModuleDiagonal,
  });
}

/** Download the component list as a flat .xlsx sheet. */
export async function exportComponentList(): Promise<Result<null>> {
  const { rows } = bomState.get();
  const result = await componentListToXlsx(rows);

  if (result.error) {
    setHud(result.error.msg);
    return { error: result.error };
  }
  if (!result.data) {
    return { data: null };
  }

  download(result.data, "haki-component-list.xlsx");
  setHud(`Component list exported — ${rows.length} rows`);

  return { data: null };
}
